import React from 'react';
import Layout from './components/Layout';
import Unauthorized from './components/Unauthorized';
import Page from './pages/Page';
import CreateUser from './pages/users/CreateUser';
import EditUser from './pages/users/EditUser';
import UserList from './pages/users/UserList';
import EditTeam from './pages/teams/EditTeam';
import ManageTeams from './pages/teams/ManageTeams';
import ManageDocuments from './pages/ManageDocuments';
import Settings from './pages/Settings';
import LoginForm from './pages/LoginForm';
import LoginAgent from './pages/LoginAgent';
import EnvironmentWizard from './pages/EnvironmentWizard';
import RequireAuth from './components/RequireAuth';

import {Routes, Route} from 'react-router-dom';
import CreateTeam from './pages/teams/CreateTeam';
import ErrorPage from './pages/ErrorPage';

class App extends React.Component {
  render() {
    return (
        <Routes>
          <Route element={<Layout/>}>
            {/* Public routes */}
            <Route path="Login" element={<LoginForm/>}/>
            <Route path="LoginAgent" element={<LoginAgent/>}/>
            <Route path="CreateUser" element={<CreateUser/>}/>
            <Route path="Unauthorized" element={<Unauthorized/>}/>
            <Route path='Error' element={<ErrorPage/>}/>
            {/* Protected routes */}
            <Route element={<RequireAuth/>}>
              <Route index element={<Page/>}/>
              <Route path="EditUser" element={<EditUser/>}/>
              <Route path="EditTeam" element={<EditTeam/>}/>
              <Route path="Users" element={<UserList/>}/>
              <Route path='Teams' element={<ManageTeams/>}/>
              <Route path='CreateTeam' element={<CreateTeam/>}/>
              <Route path="ManageDocuments" element={<ManageDocuments/>}/>
              <Route path="Settings" element={<Settings/>}/>
              <Route path="Wizard" element={<EnvironmentWizard/>}/>
            </Route>
          </Route>
        </Routes>
    );
  }
}

export default App;
